import React from "react";
import {InvitedUsersUIProvider} from "../components/InvitedUsersUIContext";
import { InvitedUsersLoadingDialog } from "../components/InvitedUsersLoadingDialog/InvitedUsersLoadingDialog";
import {InvitedUsersCard} from './InvitedUsersCard';

export function InvitedUsersPage() {
  const invitedUsersUIEvents = {};

  return (
    <InvitedUsersUIProvider invitedUsersUIEvents={invitedUsersUIEvents}>
      <InvitedUsersLoadingDialog />
      <InvitedUsersCard/>
    </InvitedUsersUIProvider>
  );
}
